export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/counter_strike.bd6400e.svg";